export default "__VITE_ASSET__BOei3iG6__"